import script from "./AdministratorProjectTeam.vue?vue&type=script&setup=true&lang=js"
export * from "./AdministratorProjectTeam.vue?vue&type=script&setup=true&lang=js"

import "./AdministratorProjectTeam.vue?vue&type=style&index=0&id=3012b067&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3012b067"]])

export default __exports__